<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Username"
          name="username"
          type="text"
          filled
          v-model="userData.Username"
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Email"
          name="email "
          type="text"
          filled
          v-model="userData.Email"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Password"
          name="password"
          filled
          @click:append="showPassword"
          v-model="userData.Password"
          :type="passwordFieldType"
          :append-icon="passwordIcon"
        ></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field
          ref="input"
          label="Conferma Password"
          name="confermaPassword"
          v-model="userData.RPassword"
          @click:append="showPassword"
          filled
          :type="passwordFieldType"
          :append-icon="passwordIcon"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="Errors != ''">
      <v-alert color="red" dense outlined type="error">{{ Errors }}</v-alert>
    </v-row>
    <v-row v-if="Alerts != ''">
      <v-alert color="blue" dense outlined type="info">{{ Alerts }}</v-alert>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["userData"],
  data: () => ({
    Info: null,
    passwordIcon: "mdi-lock",
    passwordFieldType: "password",
  }),
  methods: {
    showPassword() {
      this.passwordIcon =
        this.passwordIcon === "mdi-lock" ? "mdi-lock-open-variant" : "mdi-lock";
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
  },
  watch: {},
  computed: {
    Errors: {
      get() {
        if (!this.userData.HasValidMail() && this.userData.Email !== "")
          return "L'email inserita non è valida";
        if (
          !this.userData.HasValidPassword() &&
          this.userData.Password.length >= this.userData.MinLenPassword()
        )
          return "La password inserita non rispetta i criteri minimi di sicurezza";
        if (
          !this.userData.PasswordConfirmed() &&
          this.userData.RPassword.length >= this.userData.MinLenPassword()
        )
          return "Le password non corrispondono";
        return "";
      },
    },

    Alerts: {
      get() {
        if (
          !this.userData.HasValidPassword() &&
          this.userData.Password.length > 0
        )
          return "La password deve avere una lunghezza di minimo 8 caratteri e deve contenere sia caratteri numerici che alfabetici";

        return "";
      },
    },
  },
  mounted() {
    //eventInfo:this.eventInfo,
  },
};
</script>
